const routes = [
    {
      path: "solicitacao-servico",
      component: () => import("@/views/cliente/solitacoes_servicos/SolicitacoesServicos.vue"),
      meta: {
        menu: "dashboard",
        title: "Solicitação-Serviço",
      },
    },
  ];
  
  export default routes;
  